import { render, staticRenderFns } from "./AddEditFolder.vue?vue&type=template&id=6ed8cce2&scoped=true"
import script from "./AddEditFolder.vue?vue&type=script&lang=js"
export * from "./AddEditFolder.vue?vue&type=script&lang=js"
import style0 from "./AddEditFolder.vue?vue&type=style&index=0&id=6ed8cce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8cce2",
  null
  
)

export default component.exports